import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import WindowTypes from './components/WindowTypes';
import WhatsAppVisio from './components/WhatsAppVisio';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import ServiceZones from './components/ServiceZones';
import FAQ from './components/FAQ';
import About from './components/About';
import SeoContent from './components/SeoContent';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import CookieBanner from './components/CookieBanner';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <WindowTypes />
      <WhatsAppVisio />
      <Portfolio />
      <Testimonials />
      <ServiceZones />
      <FAQ />
      <About />
      <SeoContent />
      <ContactForm />
      <Footer />
      <FloatingButtons />
      <CookieBanner />
    </div>
  );
};

export default HomePage;
